import * as api from "../../../service/ApiSevice";
import Enums from "../../../enums/enums";
import helper from "../../../helper/shareHelper";
export const actions = {
  DoSetForgotPwd({ commit, state }, username) {
    state.setForgotPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    api.UserService.DoSetForgotPwd(username).then((res) => {
      if (res.responseCode == Enums.HttpStatusCode.OK) {
        commit("MutationSetForgotPwd");
      } else {
        state.setForgotPwdLoadingStatusType = Enums.LoadingStatusType.Failed;
      }
    });
  },
  DoGetForgotPwd({ commit, state }, _input) {
    state.getForgotPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    let input = {
      forgotPwdId: _input.a,
      forgotPwdCode: _input.b,
    };
    api.UserService.DoGetForgotPwd(input).then((res) => {
      if (res.responseCode == Enums.HttpStatusCode.OK) {
        commit("MutationGetForgotPwd", res.forgotPwd);
      } else {
        state.getForgotPwdLoadingStatusType = Enums.LoadingStatusType.Failed;
      }
    });
  },
  DoResetPwd({ commit, state }, _password) {
    state.resetPwdLoadingStatusType = Enums.LoadingStatusType.Loading;
    let passwordToken = helper.CreateToken(_password);
    let input = {
      forgotPwdId: state.forgotPwd.id,
      forgotPwdCode: state.forgotPwd.forgotPwdCode,
      password: passwordToken,
    };

    api.UserService.DoResetPwd(input).then((res) => {
      if (res.responseCode == Enums.HttpStatusCode.OK) {
        commit("MutationResetPwd");
      }
    });
  },
};
